<template>
  <v-container-restricted
    class="d-flex flex-column align-center"
    :class="Spacings.homePageSectionPadding"
  >
    <underlined-heading text="Acheived Results"></underlined-heading>

    <v-row class="text-left" :class="Spacings.homePageHeadingMargin" no-gutters>
      <v-col
        class="px-0 pb-3 pt-0 pa-sm-3"
        cols="12"
        sm="6"
        v-for="(point, index) in resultsData"
      >
        <SlideOnIntersectContainer
          :direction="
            index === 0
              ? 'top-left'
              : index === 1
              ? 'top-right'
              : index === 2
              ? 'bottom-left'
              : 'bottom-right'
          "
        >
          <template #default>
            <v-card class="h-100" elevation="0">
              <v-row no-gutters class="text-center ga-3 flex-nowrap">
                <v-icon
                  color="secondary"
                  size="50"
                  icon="mdi-check-circle"
                ></v-icon>

                <v-container-np class="flex-1-1 text-left">
                  <h4 class="text-h6">{{ point.name }}</h4>
                  <p class="text-card">{{ point.description }}</p>
                </v-container-np>
              </v-row>
            </v-card>
          </template>
        </SlideOnIntersectContainer>
      </v-col>
    </v-row>
  </v-container-restricted>
</template>
<script lang="ts" setup>
import { Spacings } from "~/core/constants/vuetify-class-constants/spacings";

const resultsData: { name: string; description: string }[] = [
  {
    name: "Reduced Return Rates",
    description:
      "The virtual try-on feature can lead to a 25% reduction in return rates within the first three months of production.",
  },
  {
    name: "Increased Engagement",
    description:
      "Customer engagement on the platform can increase by 40%, with more time spent exploring and trying different clothing items virtually.",
  },
  {
    name: "Higher Conversion Rates",
    description:
      "The feature contributed to a 20% increase in conversion rates, as customers felt more confident in their purchases.",
  },
  {
    name: "Positive Customer Feedback",
    description:
      "Customers reported a higher level of satisfaction with the shopping experience, appreciating the ability to see how clothes would look on them before buying.",
  },
];
</script>
